export const refs = {
  categoriesListEl: document.querySelector('.js-event-category-list'),
  categoriesListOpenSvgBtn: document.querySelector('.icon-rotate'),
  caregoryListSelect: document.querySelector('.event-category-select'),
  categoriesListOpen: document.querySelector('.event-category-list'),
  eventsList: document.querySelector('.events-list'),
  firstCategoryButton: document.querySelector('.categories__btn'),
  showMoreBtn: document.querySelector('.show-more-btn'),
  loader: document.querySelector('.loader'),
  eventDetailsBtn: document.querySelector('.event-details-btn'),
  categoriesScroll: document.querySelector('.categories-scroll'),
};
